export const usePopoverElectron = () => {
  const { popoverElectron, electron } = window;

  const popover = popoverElectron ?? electron?.popover;

  return {
    isPopoverElectron: !!popover,
    onClose: popover?.closePopover,
    getCreationData: popover?.getTaskCreationData,
    createTask: popover?.sendTaskData,
    setHeight: popover?.setHeight,
  };
};
